module.exports = __webpack_public_path__ + "img/doctor.c0aa0547.png";